import { ElMessage } from 'element-plus/es';
import 'element-plus/es/components/message/style/css';
import { reactive, toRefs } from "vue";
import apis from "@/api";
import common from "../composables/common";
import { Check, Close } from '@element-plus/icons-vue';
export default {
  name: "MngerAudit",
  components: {
    Check,
    Close
  },
  props: {
    demandId: String,
    visible: {
      type: Boolean,
      default: false
    }
  },
  setup(props, context) {
    const {
      getSrcType
    } = common();
    const data = reactive({
      loading: false,
      audit: {
        approveState: null,
        aprroveContent: ''
      }
    });
    const close = () => {
      context.emit('update:visible', false);
      data.audit.approveState = 0;
      data.audit.aprroveContent = '';
    };
    const hanldeSubmit = () => {
      // 审批状态非空校验
      if (!data.audit.approveState) {
        ElMessage.error('请选择审批结果');
      } else if (!data.audit.aprroveContent && data.audit.approveState != 1) {
        ElMessage.error('请输入审核备注内容');
      } else {
        data.loading = true;
        data.audit.demandId = props.demandId;
        console.log('data.audit: ', data.audit);
        apis.mngeraudit(data.audit).then(res => {
          if (res.success) {
            ElMessage({
              type: 'success',
              message: '审批成功'
            });
            context.emit('success');
            data.loading = false;
            close();
          } else {
            ElMessage.error(res.msg);
          }
        });
      }
    };
    return {
      ...toRefs(data),
      getSrcType,
      close,
      hanldeSubmit
    };
  }
};